import _isNil from 'lodash/isNil';

export const PersistenceConfig = {
    slices: ['browserPersistence'],
    storageKey: 'koruBrowserPersistence',
};

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem(
            PersistenceConfig.storageKey
        );
        if (_isNil(serializedState)) {
            return undefined;
        }
        const fullState = JSON.parse(serializedState);

        // Only return the slices that should be persisted
        return PersistenceConfig.slices.reduce((persistedState, sliceName) => {
            if (fullState[sliceName]) {
                persistedState[sliceName] = fullState[sliceName];
            }
            return persistedState;
        }, {});
    } catch (err) {
        console.error('Error loading state:', err);
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        // Only save the configured slices
        const stateToSave = PersistenceConfig.slices.reduce(
            (persistedState, sliceName) => {
                if (state[sliceName]) {
                    persistedState[sliceName] = state[sliceName];
                }
                return persistedState;
            },
            {}
        );

        const serializedState = JSON.stringify(stateToSave);
        localStorage.setItem(PersistenceConfig.storageKey, serializedState);
    } catch (err) {
        console.error('Error saving state:', err);
    }
};
